import React from "react";
import useStyles from "../styles";
import {ArrowBackIosRounded, ArrowForwardIosRounded} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";

const ukMonths = ["січень", "лютий", "березень", "квітень", "травень", "червень",
    "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"];

const ukMonthsGenitiveCase = ["січня", "лютого", "березня", "квітня", "травня", "червня",
    "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"];

const Heading = ({selectedYear, selectedMonth, selectedDay, handleChangeMonth, checked}) => {
    const cl = useStyles();

    return (<>
        <div className={cl.monthHeading}>
            <h1
                className={cl.monthHeadingText}
            >
                ВИБРАНА ДАТА
            </h1>
            {selectedYear && selectedMonth && selectedDay && <div className={cl.timeHeaderWrapperSelected}>
                {`${selectedDay.dayNum} ${ukMonthsGenitiveCase[ukMonths.indexOf(selectedMonth)]} ${selectedYear}`}
            </div>}
        </div>
        <div className={cl.monthSelectionWrapper}>
            <IconButton color="inherit" className={cl.monthSelectionButton} onClick={(e) => handleChangeMonth(e, true, false)}
                        disabled={checked}>
                <ArrowBackIosRounded/>
            </IconButton>
            <div className={cl.monthSelectionTextWrapper}>
                {selectedMonth + ' ' + selectedYear}
            </div>
            <IconButton color="inherit" className={cl.monthSelectionButton} onClick={(e) => handleChangeMonth(e, false, false)}
                        disabled={checked}>
                <ArrowForwardIosRounded/>
            </IconButton>
        </div>
        <div className={cl.shortNamesWrapper}>
            <div className={cl.dayShortName}>Пн.</div>
            <div className={cl.dayShortName}>Вт.</div>
            <div className={cl.dayShortName}>Ср.</div>
            <div className={cl.dayShortName}>Чт.</div>
            <div className={cl.dayShortName}>Пт.</div>
            <div className={cl.dayShortName}>Сб.</div>
            <div className={cl.dayShortName}>Нд.</div>
        </div>
    </>);
};

export default Heading;